//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const HidePaymentsReceiptFromPdfs: FeatureFlag = {"Id":"HidePaymentsReceiptFromPdfs","Label":"Hide payments receipt on pdfs by default","Impact":"When adding a payment to a form with generated PDF, set the payment information section to hide on the PDF","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
